import { Type } from '@angular/core';
import { BaseSecureDetails, BaseSecureSearch } from '../modules/tcm-common';
import { TcmSecureBaseComponent } from '../modules/tcm-common/security/tcm-secure-base-component';
import { TcmBaseDetails } from '../modules/tcm-common/base/tcm-base-details';

export class ReflectionHelper {

    private static secureTypes = [
        BaseSecureDetails,
        BaseSecureSearch,
        TcmSecureBaseComponent
    ];

    static isSecureComponent(componentType: Type<any>): boolean {
        return ReflectionHelper.secureTypes.some(t => componentType.prototype instanceof t);
    }
}